export default "__VITE_ASSET__EhdfVKxf__"